import i18next from 'i18next';
const lang = {
    hedef_sayi_bulalim_logo: 'img/games/hedef_sayi_bulalim/logo.png',
    hedef_sayi_bulalim_button_start: 'Start',
    hedef_sayi_bulalim_button_back: 'Back',
    hedef_sayi_bulalim_description_first_multiplier: '1st Player',
    hedef_sayi_bulalim_description_second_multiplier: '2nd Player',
    hedef_sayi_bulalim_description_gamer: '{{gamer}}. Player',
    hedef_sayi_bulalim_gamer_wait_description: 'Waiting for the other player.',
    hedef_sayi_bulalim_title_time: 'Time',
    hedef_sayi_bulalim_title_target: 'Target',
    hedef_sayi_bulalim_title_button_clear: 'Clear',
    hedef_sayi_bulalim_title_button_back: 'Undo',
    hedef_sayi_bulalim_title_button_hint: 'Hint',
    hedef_sayi_bulalim_title_button_new_question: 'New Question',
    hedef_sayi_bulalim_title_second: 'Second',
    hedef_sayi_bulalim_title_no_time: 'No Time',
    hedef_sayi_bulalim_title_difficulty_easy: 'Easy',
    hedef_sayi_bulalim_title_difficulty_medium: 'Medium',
    hedef_sayi_bulalim_title_difficulty_hard: 'Hard',
    hedef_sayi_bulalim_title_true_count: '{{count}} Correct',
    hedef_sayi_bulalim_title_point: 'Point',
    hedef_sayi_bulalim_title_record: 'Record',
    hedef_sayi_bulalim_title_winning: 'Winner',
    hedef_sayi_bulalim_description_record: 'Congratulations, you have a new record.',
    hedef_sayi_bulalim_description_landscape: 'Please use your device in landscape mode!',
    hedef_sayi_bulalim_result_feedback_1: 'You\'re a genius!',
    hedef_sayi_bulalim_result_feedback_2: 'You\'re a brainiac!',
    hedef_sayi_bulalim_result_feedback_3: 'Average performance!',
    hedef_sayi_bulalim_result_feedback_4: 'You need to improve your arithmetic skills!',
    hedef_sayi_bulalim_info_wait: 'Stay calm for {{time}} seconds',
    hedef_sayi_bulalim_info_continue: 'You can continue solving',
    hedef_sayi_bulalim_info_error: 'You made a mistake',
    hedef_sayi_bulalim_info_notification_1: 'Congratulations',
    hedef_sayi_bulalim_info_notification_2: 'You\'re doing well',
    hedef_sayi_bulalim_info_notification_3: 'You\'re awesome',
    hedef_sayi_bulalim_info_notification_4: 'You\'re superb',
    hedef_sayi_bulalim_result_draw: 'Draw',
}

// i18next.addResourceBundle('en', 'translation', lang, true, true);
export default lang;
